<app-context-menu [options]="{ width: '240px', noSpacing: true }" #menu [clientEl]="clientEl">
  <div contextButton>
    <ng-content></ng-content>
  </div>
  <div contextContent class="ios-asset-download">
    @if (downloadMode === 'long-press') {
      <div
        class="asset-container {{ orientation }}"
        [style.aspect-ratio]="asset.version_data.data.width + '/' + asset.version_data.data.height"
      >
        <img
          [src]="assetSrc"
          width="{{ asset.version_data.data.width }}"
          height="{{ asset.version_data.data.height }}"
          (load)="onImageLoaded()"
          alt=""
        />
        <app-loading-indicator [size]="'small'"></app-loading-indicator>
      </div>
      @if (imageLoaded) {
        <h3>Long-Press to Save Image</h3>
      } @else {
        <h3>Loading Image</h3>
      }
    }
    @if (downloadMode === 'button') {
      <app-svg src="/assets/icons/64/file-question.svg" class="question-svg"></app-svg>
      <h3>Can’t Preview File</h3>
    }
    <div class="selection" (click)="sizeMenu.open()">
      {{ sizeName }} <span>({{ format }}, {{ width || asset.version_data.data.width }} x {{ height }})</span>
      <app-svg src="/assets/icons/24/arrow-down.svg"></app-svg>
    </div>
    @if (downloadMode === 'button') {
      <button
        appButton
        name="download-raw-file"
        location="ios-download-context"
        color="primary"
        height="4"
        size="3"
        class="download-button"
        [center]="true"
        spacing="4"
        shape="round"
        (click)="download.emit()"
      >
        Download File
      </button>
    }
  </div>
</app-context-menu>
<app-context-menu [options]="{ width: '240px', noSpacing: true }" #sizeMenu [clientEl]="clientEl">
  <app-download-size-selection
    [accessLevel]="accessLevel"
    [asset]="asset"
    [gallery]="gallery"
    [previewWidth]="showOptimized ? scaledPreviewWidth : undefined"
    [activeWidth]="width || asset.version_data.data.width"
    (onSelect)="updateDownloadWidth($event); menu.open()"
    contextContent
  >
  </app-download-size-selection>
</app-context-menu>
